import React from 'react';

const GlowRing = ({ value, max = 100, color, label, sublabel, size = 160 }) => {
  const percentage = Math.min(Math.max((value / max) * 100, 0), 100);
  const radius = (size - 24) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;
  const center = size / 2;

  const colorMap = {
    lime: {
      stroke: '#AAFF00',
      glow: '#AAFF00',
      text: '#AAFF00',
      shadow: '0 0 20px #AAFF0066, 0 0 40px #AAFF0033',
    },
    orange: {
      stroke: '#FF6B00',
      glow: '#FF6B00',
      text: '#FF6B00',
      shadow: '0 0 20px #FF6B0066, 0 0 40px #FF6B0033',
    },
    cyan: {
      stroke: '#00D4FF',
      glow: '#00D4FF',
      text: '#00D4FF',
      shadow: '0 0 20px #00D4FF66, 0 0 40px #00D4FF33',
    },
  };

  const c = colorMap?.[color] || colorMap?.cyan;
  const filterId = `glow-${color}-${Math.random()?.toString(36)?.substr(2, 5)}`;

  return (
    <div className="flex flex-col items-center gap-3">
      <div style={{ position: 'relative', width: size, height: size }}>
        <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
          <defs>
            <filter id={filterId} x="-50%" y="-50%" width="200%" height="200%">
              <feGaussianBlur stdDeviation="4" result="blur" />
              <feMerge>
                <feMergeNode in="blur" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>
          {/* Track */}
          <circle
            cx={center}
            cy={center}
            r={radius}
            fill="none"
            stroke="rgba(255,255,255,0.06)"
            strokeWidth="10"
          />
          {/* Progress arc */}
          <circle
            cx={center}
            cy={center}
            r={radius}
            fill="none"
            stroke={c?.stroke}
            strokeWidth="10"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            filter={`url(#${filterId})`}
            style={{ transition: 'stroke-dashoffset 0.8s ease' }}
          />
        </svg>
        {/* Center text */}
        <div
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <span
            style={{
              fontFamily: "'Inter Tight', 'Inter', sans-serif",
              fontWeight: 800,
              fontSize: size > 140 ? '1.75rem' : '1.25rem',
              color: c?.text,
              textShadow: c?.shadow,
              lineHeight: 1,
              letterSpacing: '-0.02em',
            }}
          >
            {typeof value === 'number' ? value?.toLocaleString() : value}
          </span>
          {sublabel && (
            <span style={{ fontSize: '0.65rem', color: 'rgba(255,255,255,0.5)', marginTop: 2 }}>
              {sublabel}
            </span>
          )}
        </div>
      </div>
      {label && (
        <div className="text-center">
          <p style={{ fontSize: '0.7rem', color: 'rgba(255,255,255,0.45)', textTransform: 'uppercase', letterSpacing: '0.1em' }}>
            Progress
          </p>
          <p style={{ fontSize: '0.85rem', fontWeight: 700, color: c?.text, fontFamily: "'Inter Tight', 'Inter', sans-serif" }}>
            {percentage?.toFixed(0)}%
          </p>
        </div>
      )}
    </div>
  );
};

export default GlowRing;
